import { Box, Button, Card, em, Flex, Image, Rating, Text } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconCircleMinus, IconShoppingCartPlus } from '@tabler/icons-react'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import fallbackImage from '../assets/Placholder-01.png'
import Colors from '../constants/colors.ts'
import { IFood } from '../interfaces/buyer/restaurants/IRestaurantResponse.ts'
import {
	addToCartAction,
	deleteCartItemAction,
} from '../store/product/productActions.ts'
import { useAppDispatch } from '../store/store.ts'
import { calculateRatings, calculateStars } from '../utils/ratingCalculator.ts'
import { round } from '../utils/roundOffFunction.ts'

type FoodItemCardProp = {
	isPlus?: boolean
	key: number | string
	food: IFood
	user: string
}
const FoodItemCard = ({ key, food, user }: FoodItemCardProp) => {
	const [isPlus, setIsPlus] = useState(true)
	const dispatch = useAppDispatch()
	const isMobile = useMediaQuery(`(max-width: ${em(768)})`)
	const navigate = useNavigate()

	const ratings = useMemo(
		() => calculateRatings(food?.rating?.totalRating, food?.rating?.numRating),
		[food]
	)

	const stars = useMemo(
		() => calculateStars(food?.rating?.totalRating, food?.rating?.numRating),
		[food]
	)

	return (
		<Flex
			key={key}
			w={isMobile ? '165px' : '225px'}
			h={isMobile ? '260px' : '320px'}
			gap='sm'
			bg={'#F3F3F3'}
			my='xs'
			style={{ cursor: 'pointer', borderRadius: '10px' }}
		>
			<Card
				w='100%'
				pos='relative'
				radius='lg'
				padding={'sm'}
				bg={'transparent'}
			>
				<Flex
					align='center'
					h='100%'
					direction='column'
					justify='space-between'
				>
					<Card.Section>
						<Box
							bg={'white'}
							p={10}
							w={isMobile ? '200px' : '330px'}
							h={isMobile ? '160px' : '200px'}
							style={{
								borderRadius: '10px',
							}}
						>
							<Image
								radius='sm'
								src={food?.productImage}
								fit='contain'
								w={'100%'}
								h={'100%'}
								fallbackSrc={fallbackImage}
							/>
						</Box>
					</Card.Section>
					<Flex w={'100%'} direction='column' my='xs' align={'start'}>
						<Text lineClamp={2} size='sm'>
							{food?.productName}
						</Text>
						<Text size='sm' fw={600}>
							{round(food?.productPrice?.amount)} {food?.productPrice?.currency}
						</Text>
						<Flex align={'center'} my={5} gap={10}>
							<Rating
								defaultValue={stars}
								color='#FFC633'
								size='xs'
								readOnly
								fractions={4}
							/>
							<Text size='sm' c={'#979797'}>
								{ratings}
							</Text>
						</Flex>
					</Flex>
					{/* <Flex align={'center'} my={5} gap={10}>
						<Rating
							defaultValue={stars}
							color='#FFC633'
							size='xs'
							readOnly
							fractions={4}
						/>
						<Text size='sm' c={'#979797'}>
							{ratings}
						</Text>
					</Flex> */}
					{isPlus ? (
						<Button
							component='a'
							fw={100}
							variant='outline'
							radius='md'
							c='#62BE12'
							color='#F5F6FA'
							pos='absolute'
							h={'max-content'}
							bottom={8}
							right={4}
							style={{
								border: '0.5px solid #AAE104',
								borderRadius: '15px',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
							onClick={() => {
								if (user === 'guest') {
									navigate('/sign-in')
								} else {
									setIsPlus(!isPlus)
									dispatch(addToCartAction({ productId: food._id }))
								}
							}}
							// leftSection={<IconCirclePlus size='1.2rem' />}
						>
							<IconShoppingCartPlus size='18px' color={Colors.primaryColor} />
						</Button>
					) : (
						<Button
							component='a'
							fw={200}
							w='100%'
							color='#62BE12'
							onClick={() => {
								setIsPlus(!isPlus)
								dispatch(deleteCartItemAction({ productId: food._id }))
							}}
							leftSection={<IconCircleMinus size='1.2rem' />}
						>
							Remove
						</Button>
					)}
				</Flex>
			</Card>
		</Flex>
	)
}

export default FoodItemCard
